import { styled } from '@mui/material';

export const StyledForm = styled('form')({
  width: '100%',
  display: 'flex',
});
